<template>
    <div class="smart-form" :id="config.id" :class="status" v-focus-visible>
        <smart-form-debug :formData="{fields: form, state: status, prefill: prefillData, settings: settings, endpoint: endpoint, config: config, version: version, ga: ga}" v-if="debug"></smart-form-debug>
        <div class="py-sf-spinner" v-if="status.processing"></div>
        <s-form class="py-smart-form" @submit="onSubmit" @reset="onReset" v-if="!messaging.show">
            <p class="py-sf-reset-msg" v-if="status.prefilled">{{ $t('message.resetText') }} <a href="javascript:void(0)" @click="resetPrefill">{{ $t('message.resetLinkText') }}</a> {{ $t('message.resetText2') }}</p>
            <slot></slot>
            <div class="py-sf-privacy" v-if="status.loaded">
                <div v-if="status.apjPrivacy" class="py-sf-apjPrivacy">
                    <label><b>{{ $t('message.apjPrivacy.title')}}</b></label>
                    <p><b>{{ $t('message.apjPrivacy.company')}}</b> {{ $t('message.apjPrivacy.part1')}} <a :href="$t('message.privacyLink')" target="_blank">{{ $t('message.apjPrivacy.linkText')}}</a> {{ $t('message.apjPrivacy.part2')}}</p>
                    <s-form-group>
                        <s-form-checkbox v-model="form.Privacy" id="Privacy" name="Privacy" value="1" required>{{ $t('message.apjPrivacy.privacyAccept')}}</s-form-checkbox>
                    </s-form-group>
                </div>
                <div v-else>
                    <label>{{ $t('message.privacyText')}} <a :href="$t('message.privacyLink')" target="_blank">{{ $t('message.privacyLinkLabel') }}</a>{{ $t('message.privacyText2') }}</label>
                </div>
            </div>

            <div class="py-sf-btn-grp" v-if="config.success === 'true'">
                <s-button type="submit" variant="primary" v-focus-visible="true">{{ $t('message.submitBtn["'+submitButtonLabel+'"]') }}</s-button>
                <!--<b-button type="reset" variant="secondary">Reset</b-button>-->
            </div>
        </s-form>
        <div v-if="messaging.show" class="py-sf-msg" :class="messaging.style">
            <p v-if="messaging.type === 'warning'"><span>Warning</span>{{ messaging.msg }}</p>
            <p v-if="messaging.type === 'errorLoading'"><span>{{$t('message.form.error')}}</span>{{$t('message.form.errorLoading')}}</p>
            <p v-if="messaging.type === 'submissionProblem'"><span>{{$t('message.form.error')}}</span>{{$t('message.form.submissionProblem')}} <a href="#" v-on:click.stop="resetMessaging">{{$t('message.form.click_here')}}.</a></p>
            <p v-if="messaging.type === 'submissionSuccess'"><span>{{$t('message.form.thankyou')}}</span>{{$t('message.form.submissionSuccess')}}</p>
        </div>
    </div>
</template>

<script>

    import SmartFormDebug from "./SmartForm_Debug"
    import GA_CONFIG from '../utils/mappings/gaConfig'
    import TRANSLATIONS from '../translations'
    import TEMPLATE_CONFIGURATIONS from '../templates/configurations'
    import Prod_Domain_List from '../utils/mappings/prodDomainList'
    import sFormCheckbox from '../components/form/s-form-checkbox'
    import sFormGroup from '../components/form/s-form-group'
    import sForm from '../components/form/s-form'
    import sButton from '../components/form/s-button'
    import * as FormTypes from '../utils/classes/FormTypes'
    import ConversionHelper from '../utils/helpers/conversionHelper'

    export default {
        name: 'smart-form',
        components: {
            SmartFormDebug,
            sFormCheckbox,
            sFormGroup,
            sForm,
            sButton
        },
        inject: {
            $validator: '$validator'
        },
        data(){
            return {
                instance: null,
                version: process.env.VUE_APP_VERSION,
                endpoint: (Prod_Domain_List.includes(window.location.hostname)) ? process.env.VUE_APP_MARTEL_ENDPOINT_PROD : process.env.VUE_APP_MARTEL_ENDPOINT_STAGING,
                messaging: {
                    fail: false,
                    msg: "",
                    type: ""
                },
                disabled: false,
                debug: this.debugMode,
                debugKey: "ctxdebug",
                form: this.schema.fields,
                settings: {
                    onPageRedirect: (this.config.redirect.indexOf("#") === 0),
                    formType: "SmartForm",
                    demandbaseEnabled: true,
                    demandbaseWidgetEnabled: true,
                    prefillEnabled: true,
                    geoNamesEnabled: true,
                    marketoMunckinEnabled: false,
                    skipForm: (this.config.skipform === "true"),
                    blockSubmit: false,
                    rules: {}
                },
                ga: {
                    host: this.config.ga_host,
                    conversionsEnabled: false
                },
                defaults: {
                    programName: this.config.programcode,
                    type: "Normal"
                },
                status: {
                    loaded: (this.config.success === "true"),
                    processing: true,
                    gdpr: false,
                    apjPrivacy: false,
                    ready: false,
                    prefilled: false,
                    submittedAttempt: false
                },
                prefillData : {}
            }
        },
        props: {
            config: Object,
            schema: Object,
            language: {
                type: String,
                default: "en-us"
            },
            debugMode: {
                type: Boolean,
                default: false
            }
        },
        computed:{
            submitButtonLabel(){

                //legacy check for old admin rules
                if(this.settings.rules.submitBtn){
                    if(this.hasTranslation(this.settings.rules.submitBtn)){
                        return this.settings.rules.submitBtn
                    }
                }

                //check data attribute for button label
                if(this.config.buttonlabel){
                    if(this.hasTranslation(this.config.buttonlabel)){
                        return this.config.buttonlabel
                    }
                }

                //return default submit label
                return  "Submit"
            },
            country(){
                return this.form.country
            },
            phoneOK(){
                return this.form.OK_to_Call__c
            },
            phone(){
                return this.form.phone
            },
            Sales_Contact_Requested__c(){
                return this.form.Sales_Contact_Requested__c
            },
            Email_Blast_OK__c(){
                return this.form.Email_Blast_OK__c
            },
            Unsubscribed(){
                return this.form.Unsubscribed
            }
        },
        watch: {
            country(val){
                this.instance.handleCountrySwitch(val)
            },
            phoneOK(val){
                this.instance.handlePhoneOKSwitch(val)
            },
            phone(val){
                this.instance.handlePhoneChange(val)
            },
            Sales_Contact_Requested__c(val) {
                this.instance.handleSalesContactChange(val)
            },
            Email_Blast_OK__c(val){
                if(val === 'Yes'){
                    this.form.Unsubscribed = 'No'
                }
            },
            Unsubscribed(val){
                if(val === 'Yes'){
                    this.form.Email_Blast_OK__c = 'No'
                }
            }
        },
        beforeCreate(){

        },
        created(){

            //consume template settings to override defaults
            this.handleConfig()

            // show error message if form did not load from template
            if (!this.status.loaded) {
                this.messaging = {
                    show: true,
                    type: "errorLoading",
                    style: "error"
                }
                this.status.processing = false
                this.handleAppError("Template failed to load")
                return
            } else {
                this.consoleLog(`form loaded [version ${this.version}]`)
            }

            //create the new form instance
            this.settings.formType = (this.config.formtype !== undefined && this.config.formtype !== "") ? this.config.formtype : this.settings.formType
            const typeClass = FormTypes.getTypeClass(this.settings.formType)
            this.instance = new typeClass(Object.assign(this.$data, this.$props), this.forceUpdate)

            //override defaults if set
            if(this.settings.rules.hasOwnProperty('defaults')){
                for(let field in this.settings.rules.defaults){
                    if(this.form.hasOwnProperty(field)){
                        this.form[field] = this.settings.rules.defaults[field]
                    }
                }
            }

            //prefill the form from local storage values
            this.instance.prefill()

        },
        mounted(){

            // check redirect and throw warning if same as form page
            if((this.getCleanUrlPath(this.config.redirect) === this.getCleanUrlPath(window.location.pathname)) && this.settings.skipForm){

                this.messaging = {
                    show: true,
                    type: "warning",
                    style: "warning",
                    msg: "Thank you page is the same as the current page, this will result in a submission loop when skip form is enabled."
                }
                this.handleAppError("Redirect matches form page")
                this.status.processing = false
                return

            }

            /**
             * Move on-page thank you message from template
             */
            if(this.settings.onPageRedirect){
                try{
                    this.$el.appendChild(document.getElementById(this.config.redirect.replace("#", "")))
                }catch(e){
                    this.messaging = {
                        show: true,
                        type: "warning",
                        style: "warning",
                        msg: `Thank you element not found in template (${this.config.redirect})`
                    }
                    this.status.processing = false
                    return
                }
            }

            //init campaign hierarchy
            this.instance.initCampaignHierarchy();

            // handle skip form is fields are prefilled
            if (this.settings.skipForm) {
                this.attemptSkipForm(this.submitData)
            }

            //load demandbase if enabled
            if (this.settings.demandbaseEnabled) {
                this.instance.initDemandBase()
            }

            //allow extra time for form spinner while things load
            let self = this
            window.setTimeout(function () {
                self.status.processing = false
            }, 500)

            //check for prefills and set labels properly if value exists
            this.instance.updateFieldStates()

            /**
             * listen for pylon specific input events
             */
            this.addEventListeners()

            this.status.ready = true

            /**
             * form has loaded, track via GA
             */
            window.addEventListener('load', (event) => {
                self.trackForm()
            });

        },
        methods: {
            addEventListeners(){
                let self = this

                this.$on("pyInputBlur", function(field){
                    switch(field.name){
                        case 'postalCode':
                            if(self.settings.geoNamesEnabled){
                                self.instance.handleGeoNames()
                            }
                            break
                        case 'firstName':
                            this.checkDebug(field)
                            break
                        case 'email':
                            this.checkDebug(field)
                            self.instance.handleEmailChange(field.value)
                            break
                        case 'Company_Self_Reported__c':
                            /** fixes issue with demandbase dropdown populating field with value **/
                            self.form.company = field.value
                            break
                        default:
                            break
                    }

                    //only perform validation on field blur if submission attempted at least once
                    if(self.status.submittedAttempt) {
                        self.$validator.validate(field.name).then(function () {
                            self.instance.handleErrors(self.errors)
                        }).catch(function(e){
                            self.consoleLog(e)
                        })
                    }
                })

                this.$on("pyInputChange", function(field){
                    switch(field.name){
                        case 'country':
                            self.form.city = ""
                            self.form.state = ""
                            self.form.postalCode = ""
                            break
                        case 'Unsubscribed' :
                            this.handlePrefCenterAlert(field)
                            break
                        default:
                            break
                    }

                    window.setTimeout(function(){
                        //only perform validation on field blur if submission attempted at least once
                        if(self.status.submittedAttempt) {
                            self.validate()
                        }
                    }, 100)
                })

                this.$on("closeDebug", function(){
                    this.debug = false
                })
            },
            
            //preference-center -- displaying alert message when user checks the Unsubscribe checkbox
            handlePrefCenterAlert(field) {
                var alertBox = document.querySelector(".pc-alert"); 
                if (field.checked) {
                    if (alertBox.classList.contains('hidden')) {
                        alertBox.classList.remove('hidden');
                        setTimeout(function () {
                            alertBox.classList.remove('visuallyhidden');
                        }, 20);
                    }
                }
                else {
                    alertBox.classList.add('visuallyhidden');    
                    alertBox.addEventListener('transitionend', function() {
                        alertBox.classList.add('hidden');
                    }, {
                    capture: false,
                    once: true,
                    passive: false
                    });
                }
            },

            loadGAConfig(){
                return {
                    host: this.config.ga_host,
                    id: GA_CONFIG[this.config.ga_host].id,
                    conversionsEnabled : GA_CONFIG[this.config.ga_host].conversionsEnabled
                }
            },
            handleConfig(){

                //init ga if host found
                this.ga = (this.config.ga_host !== "") ? this.loadGAConfig() : this.ga

                let hvht = 'Sales_Contact_Requested__c', newHvhtConfig = {}

                this.settings.rules = JSON.parse(this.config.rules)

                if(this.config.hasOwnProperty('contactsales')){
                    switch(this.config.contactsales){
                        case 'hidden':
                            newHvhtConfig = {
                                'show': false
                            }
                            break
                        case 'hidden-checked':
                            newHvhtConfig = {
                                'show': false,
                                'value': 'Yes'
                            }
                            break
                        default:
                            break
                    }
                    this.settings.rules[hvht] = newHvhtConfig
                }

                //check form template configurations and merge with rules
                if(TEMPLATE_CONFIGURATIONS.hasOwnProperty(this.config.template)){
                    this.settings.rules = Object.assign(TEMPLATE_CONFIGURATIONS[this.config.template], this.settings.rules)
                }

                //handle field values and config that exist in rules
                for(let field in this.settings.rules){
                    if(this.schema.fields.hasOwnProperty(field)){
                        Object.assign(this.schema.config[field], this.settings.rules[field])
                        this.form[field] = (this.settings.rules[field].value) ? this.settings.rules[field].value : ""
                    }
                }

                // merge embed config and template settings
                if(this.settings.rules.hasOwnProperty('settings')){
                    Object.assign(this.settings, this.settings.rules['settings'])
                }

                return true

            },
            getCleanUrlPath(url){
                return url.replace(window.location.origin, "").replace(".html", "").replace(/\/\s*$/, "").replace("/content/citrix/en_us", "")
            },
            hasTranslation(value){
                return TRANSLATIONS[this.language].message.submitBtn.hasOwnProperty(value)
            },
            resetPrefill(){
                this.instance.resetForm()
            },
            validate(callback, submitFlag){
                let self = this

                this.$validator.validate().then(valid => {
                    if (!valid) {
                        self.instance.handleErrors(this.errors)
                        self.status.submittedAttempt = true
                    }else{
                        if (callback) callback()
                    }
                    //only fire if action was form submission attempt
                    if(submitFlag) {
                        self.trackErrors(this.errors)
                    }
                }).catch(function(e){
                    self.consoleLog(e)
                })
            },
            attemptSkipForm(callback){
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        this.$validator.reset()
                    }else{
                        callback()
                    }
                }).catch(function(e){
                    self.consoleLog(e)
                })
            },
            onSubmit(e){

                e.preventDefault()

                //validate the data then pass the sumbit function if form is valid
                this.validate(this.submitData, true)

            },
            submitData(){

                let self = this

                //set form to precessing state to display spinner
                this.status.processing = true

                // set marketo cookie if one does not exist
                if(this.settings.marketoMunckinEnabled){
                    this.instance.marketoMunchkin.setMarketoCookie()
                }

                //clean data formats
                this.schema.submissionData = this.instance.cleanSubmissionData(Object.assign({}, this.form))

                //set prefill values in local storage
                this.instance.setPrefill(this.schema.submissionData)

                //dispatch submission event
                let event, eventText = 'CTX_SmartForms.formSubmitted';
                if(typeof(Event) === 'function') {
                    event = new Event(eventText, {bubbles: true});
                }else{
                    event = document.createEvent('Event');
                    event.initEvent(eventText, true, true);
                }
                this.$el.dispatchEvent(event);

                //block submission if settings allow
                if(this.settings.blockSubmit){
                    this.consoleLog("blocked form submission due to settings")
                    return
                }

                try {

                    //scroll to the top of the form if not one page experience
                    if(!this.checkOnePageExperience()){
                        document.getElementById(this.config.id).scrollIntoView({
                            behavior: 'smooth'
                        })
                    }

                    //temporarily need to remove this since we are inserting it for the test endpoint
                    delete this.schema.submissionData['Record_Processing_Type__c']

                    //send submission data to martel endpoint
                    this.instance.sendData(this.endpoint, this.schema.submissionData, function (response) {
                        self.handleResponse(response)
                        self.status.processing = false
                    })

                }catch(e){

                    this.status.processing = false
                    this.messaging = {
                        show: true,
                        style: "error",
                        type: "submissionProblem"
                    }
                    this.handleAppError("Submission failed")

                }

                return false
            },
            onReset: function(){
                let fields = Object.keys(this.form)
                for(let i = 0; i <= fields.length; i++){
                    let obj = fields[i]
                    this.form[obj] = ""
                }
            },
            handleResponse(response){
                let self = this
                if(response.status === 200){

                    //handle GA conversion events
                    if(this.ga.conversionsEnabled){
                        ConversionHelper.send(this.form.Primary_Product_Interest__c, this.form.programName, this.settings.skipForm)
                    }

                    /**
                     * check if redirect is DOM element, if so then fade in element otherwise forward to thank you page
                     */
                    if(self.config.redirect.indexOf("#") === 0){
                        this.messaging = {
                            show: true
                        }
                        document.getElementById(self.config.redirect.replace("#", "")).classList.add("show")
                    }else if(this.checkOnePageExperience()){
                        //qualifies for one page form experience
                        CTX_FormPage.handleSubmit()
                    }else{
                        this.messaging = {
                            show: true,
                            style: "general",
                            type: "submissionSuccess"
                        }
                        setTimeout(function(){
                            window.location.href = self.config.redirect
                        }, 1500)
                    }

                }else{
                    this.messaging = {
                        show: true,
                        style: "error",
                        type: "submissionProblem"
                    }
                    this.handleAppError(`Martel endpoint issue: response(${response.status})`)
                }
            },
            checkOnePageExperience(){
                /**
                 * check for AEM object and perform additional safety checks to ensure it can fire correctly
                 */
                try{
                    if(window.location.pathname.indexOf("/form/") > 0 || digitalData.page.category.pageType === "Form") {
                        if (typeof CTX_FormPage !== "undefined") {
                            if (CTX_FormPage.hasOwnProperty("handleSubmit")) {
                                if (this.config.redirect.replace(".html", "").endsWith("thank-you")) {
                                    return true
                                }
                            }
                        }
                    }
                }catch (e) {
                    return false
                }

                return false
            },
            resetMessaging(){
                this.messaging = {
                    show: false,
                    msg: "",
                    type: "",
                    style: ""
                }
            },
            forceUpdate(){
                let self = this

                //force the instance to update
                this.$forceUpdate()

                window.setTimeout(function(){
                    // check the field for values and update their state in the dom
                    self.instance.updateFieldStates()

                    // perform validation check, forceUpdate typically runs after data is changed or populated
                    if(self.status.submittedAttempt) {
                        self.validate()
                    }
                }, 200)

            },
            trackForm(){
                if(this.$ga !== undefined) {
                    this.$ga.event({
                        eventCategory: 'Smartform',
                        eventAction: window.location.href,
                        eventLabel: `${this.config.programcode} [${this.config.template}]`,
                        nonInteraction: true
                    })
                    this.consoleLog("ga form track")
                }
            },
            trackErrors(errors){
                let processedErrors = this.instance.processErrorsForGA(errors)
                if(processedErrors) {
                    if (this.$ga !== undefined) {
                        this.$ga.event({
                            eventCategory: 'Smartform Error - Validation',
                            eventAction: window.location.href,
                            eventLabel: processedErrors
                        })
                    }
                }
            },
            handleAppError(error){
                let eventLabel = (typeof error === "object") ? JSON.stringify(error) : error
                if (this.$ga !== undefined) {
                    this.$ga.event({
                        eventCategory: 'Smartform Error - Application',
                        eventAction: window.location.href,
                        eventLabel: JSON.stringify(eventLabel)
                    })
                }
            },
            consoleLog(msg){
                console.log("SMART FORM ["+this.config.id+"]: " + msg)
            },
            /**
             * check for debug key to load debug panel, erase value after verified
             * @param field
             */
            checkDebug(field){
                if(field.value === this.debugKey){
                    this.debug = true
                    this.form[field.name] = ""
                }
            }
        }
    }

</script>

<style lang="scss">

    @import "css/reboot";
    @import "~pylon-vue/src/themes/themis/_themis_form_only";
    @import "css/smartform";

</style>
